<template>
  <BaseSection
    :id="section.key"
    :is-visible="isSectionVisible"
    :is-modified="isDataChanged"
    :section="section"
    @onSectionSaveClick="save"
  >
    <template #section>
      <v-card-text class="mt-4">
        <div class="mb-5">
          <v-expand-transition>
            <v-textarea
              outlined
              name="input-7-4"
              label="Purpose"
              placeholder="Purpose"
              v-model="lendingNotes.purpose"
              rows="8"
              auto-grow
              :disabled="FIELDS_DISABLED"
            ></v-textarea>
          </v-expand-transition>

          <v-expand-transition>
            <v-textarea
              outlined
              name="input-7-4"
              label="Client Background and Character"
              placeholder="Client Background and Character"
              v-model="lendingNotes.backgrounds"
              rows="20"
              auto-grow
              :disabled="FIELDS_DISABLED"
            ></v-textarea>
          </v-expand-transition>

          <v-expand-transition>
            <v-textarea
              outlined
              name="input-7-4"
              label="Other notes"
              placeholder="Other notes"
              v-model="lendingNotes.other"
              rows="8"
              auto-grow
              :disabled="FIELDS_DISABLED"
            ></v-textarea>
          </v-expand-transition>
        </div>
      </v-card-text>
    </template>
  </BaseSection>
</template>

<script>
import { mapGetters } from 'vuex';

import { clone } from '@/utils/object';

import SectionMixin from '@/mixins/SectionMixin';

import BaseSection from '@/components/ApplicationSections/BaseSection.vue';

export default {
  name: 'LendingNotesSection',

  components: {
    BaseSection,
  },

  mixins: [SectionMixin],

  props: {
    existedData: {
      type: Object,
      default() {
        return {};
      },
    },

    section: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isSectionVisible: false,

      initialLendingNotes: {},
      lendingNotes: {},
    };
  },

  computed: {
    ...mapGetters(['FIELDS_DISABLED']),
  },

  async created() {
    await this.checkIsSectionVisible();

    this.initialLendingNotes = clone(this.existedData);
    this.lendingNotes = clone(this.existedData);

    this.$emit('componentReady');
  },
};
</script>
